import * as $ from 'jquery';
// import * as variables from '../../variables.js';
import ViewportTracker from '../../lib/ViewportTracker';

export interface Config {
	form: string,
	items: string,
	styleClass: {
		active: string
	}
}

export default class ProductFilters {
	// private readonly containerSelector: HTMLElement;
	private form: JQuery;
	private items: JQuery;
	private readonly config: Config;
	private readonly activeClass: string;
	private attached = false;

	constructor(config: Config) {
		this.config = config;
		this.form = $(config.form);
		this.items = $(config.items);
		this.activeClass = config.styleClass.active;

		if (this.form.length === 0) {
			return;
		}
		// clear the form on first run
		(this.form.get()[0] as HTMLFormElement).reset();
		this.attachOnce();
		document.addEventListener('jsfAjaxEvent', () => this.initialize());
		this.initialize();
	}
	attachOnce() {
		if (!this.attached) {
			this.attached = true;
			$(document).on('click', (event) => {
				// @ts-ignore
				if (event.target !== this.form.get(0) && $(event.target).closest("form").get(0) !== this.form.get(0)) {
					this.close();
				}
			});
		}
	}
	initialize() {
		const $form = $(this.config.form);
		if ($form.hasClass('initialized')) {
			return;
		}
		this.form = $form;
		this.items = $(this.config.items);
		$form.addClass('initialized');

		this.makeAccordion('productFilters');

		// Clicking on the placeholder
		/* $form.on('click', this.config.items + '__currentValue', (event) => {
			this.handleToggle(event);
		}); */
		// Open on space bar or enter
		$form.on('keyup', (event: any) => {
			if (event.target !== $form[0]) {
				return true;
			}
			if (event.which === 32 || event.which === 13) {
				this.handleToggle(event);
			}
		});
		// Any Change
		$form.on('change', () => {
			this.updateDisplayedFilter();
		})
		// When surrounding form is submitted close 'more filters'
		$form.closest('form').on('submit', this.close);
	}
	updateDisplayedFilter() {
		for (let i = 0, l = this.items.length; i < l; ++i) {
			let $item = $(this.items[i]);

			$item.find("input[disabled]").first().val(
				// @ts-ignore
				$item.find("input:checked").map(function () {
					return $(this).val();
				}).get().join(', ')
			);
		}
	}
	isOpen($elem: JQuery) {
		return $elem.hasClass(this.activeClass);
	}
	close() {
		(this.items).removeClass(this.activeClass);
		(this.items).off('.containerFocusout');
	}
	dropFocus(event: any) {
		if (!(this.items).is(event.target) && (this.items).has(event.target).length === 0) {
			this.close();
		}
	}
	open($elem: JQuery) {
		(this.items).removeClass(this.activeClass);
		$elem.addClass(this.activeClass);
		$(document).on('mouseup.containerFocusout focusin.containerFocusout', () => {
			this.dropFocus
		});
	}
	handleToggle(event: JQuery.ClickEvent) {
		event.preventDefault();
		var $parent: JQuery = $(event.target).parents(this.config.items);
		if (this.isOpen($parent)) {
			this.close();
		} else {
			this.open($parent);
		}
	}

	makeAccordion(blockName: String) {
		var $allFilters = $('.' + blockName);
		var $elementsTriggerToggle = $('.' + blockName + ' button');

		function filterToggleView(event:any) {
			event.preventDefault();

			var toggleValue = $allFilters.attr('aria-expanded') == 'true' ? 'false' : 'true';
			$allFilters.attr('aria-expanded', toggleValue);
		}
		if (ViewportTracker.below('mobileMenu')) {
			// Turn off
			$allFilters.attr('aria-expanded', 'false');
			$elementsTriggerToggle.on('click.filterToggle', filterToggleView);
		} else {
			// Turn on
			$allFilters.attr('aria-expanded', 'false');
			$allFilters.removeAttr('aria-expanded');
			$elementsTriggerToggle.off('click.filterToggle');
		}

	}
}
